/**
 * 배경색(hex)의 밝기를 계산해 가독성 높은 텍스트 색상 반환.
 * - 밝은 배경 → '#111827' (dark)
 * - 어두운 배경 → 'white'
 */
export function getContrastColor(hexColor) {
  if (!hexColor || typeof hexColor !== 'string') return 'white';
  const hex = hexColor.replace('#', '');
  if (hex.length !== 6) return 'white';
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? '#111827' : 'white';
}
